<template lang="pug">
  div(data-testid="content-add-done")
    section.content-header
      h1 完了

    section.content
      .alert.alert-success
        p.lead 名刺の登録が完了しました。
        p(v-if="isModeImage") 画像の解析が終わるまでしばらくお待ちください。

      .bcard-btnbar.-bottom
        router-link.btn.btn-default(:to="{name:'top'}", data-testid="add-done-btn-to-top") TOPに戻る
        |
        |
        template(v-if="isModeImage")
          router-link.btn.btn-default(v-if="isModeImage", :to="{name:'queued'}", data-testid="-btn-show-image-list") 登録待ちの名刺一覧を表示する
          |
          |
          router-link.btn.btn-primary(v-if="isNewPerson", :to="{name: 'addcard-image'}", data-testid="-btn-continue-add") 続けて登録する

        template(v-if="isModeManual")
          router-link.btn.btn-default(:to="{name: 'box-detail', params: { sidPerson, init: true }}", data-testid="add-done-btn-show-detail") 詳細画面を表示する
          |
          |
          router-link.btn.btn-primary(v-if="isNewPerson", :to="{name: 'addcard-manual'}", data-testid="add-done-btn-continue-add") 続けて登録する
</template>

<script>
export default {
  name: 'NewcardDone',
  props: {
    sidPerson: { type: [String, Number], required: true }
  },
  computed: {
    isNewPerson () {
      return this.$route.name.indexOf('clone') < 0
    },
    isModeManual () {
      return this.$route.name.indexOf('manual') > 0
    },
    isModeImage () {
      return this.$route.name.indexOf('image') > 0
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/box/NewCardDone.vue